import React, { FC } from "react";
import logoLong from "../../assets/LogoLong.svg";

import { styled } from "styled-components";

const Img = styled.img`
    height: 32px;
    width: auto;
    display: block;
    margin: auto;
`;

type Props = {
    className?: string;
    height?: number;
};

const Logo: FC<Props> = ({ className = "" }: Props) => {
    const logo = <Img src={logoLong} alt="Trilo logo" title="Trilo" />;
    return <div className={`${className}`}>{logo}</div>;
};

export default Logo;
